import moment from 'moment';

export const SERVER_DATE_MASK = 'YYYY-MM-DD';
export const PICKER_DATE_MASK = 'DD.MM.YYYY';
export const PICKER_DATE_MASK_FULL_TIME = 'DD.MM.YYYY  HH:mm';
export const PICKER_SHORT_YEAR_DATE_MASK = 'DD.MM.YY';
export const PICKER_TIME_MASK = 'HH:mm';
export const PICKER_TIME_MASK_WITH_SECONDS = 'HH:mm:ss';
export const LONG_DATE_MASK = 'D MMM YYYY h:mm';
export const PICKER_DATE_FULL_TIME_NUMBER = 'YYYYMMDDHHmmss';
export const PICKER_SHORT_DATE_MASK = 'DD MMM';
export const PICKER_YEAR_MONTH_DATE_MASK = 'YYYY-M';
export const PICKER_WEEK_DATE_MASK = 'YYYY-MM-DD-WW';

export const PICKER_DATE_MASK_PREPARE_UTC = 'YYYY-MM-DD HH:mm';

export const MIN_DATE = moment('01.01.1970', PICKER_DATE_MASK);

export const MINUTE_STEP = 15;
